import {TextLink} from "base/navigation/components";

export function useHolderPlotsTable() {
    const tableColumns = [
        {
            id: "code",
            label: "Código",
            width: 15,
            formatFunction: item => (
                <TextLink
                    text={item?.code}
                    to={`/plots/all/list/${item.id}/summary`}
                    textStyle={{fontSize: "inherit"}}
                />
            ),
        },
        {
            id: "number",
            label: "Número",
            width: 15,
        },
        {
            id: "district",
            label: "Distrito",
            width: 15,
        },
        {
            id: "locality",
            label: "Localidade",
            width: 15,
        },
        {
            id: "land_ownership",
            label: "Propriedade da terra",
            width: 20,
        },
        {
            id: "land_cover",
            label: "Cobertura",
            width: 20,
        },
    ];

    return {tableColumns};
}
